import { Outlet } from 'react-router-dom';
import { HeartHandshake, FileTerminal, ReceiptText, Receipt } from 'lucide-react';
import type { MenuItemsType } from '@duke-hq/ui/components/SubSidebar/MenuItems';
import { SidebarLayout } from '@duke-hq/ui/components/SubSidebar/SidebarLayout';
import { t } from '@lingui/core/macro';
import { withPermission } from '../withPermission';

export const FinancesLayout = withPermission('canViewFinances', () => {
  const items: MenuItemsType[] = [
    {
      label: t`Invoices`,
      link: `/finances/invoices`,
      icon: ReceiptText,
    },
    {
      label: t`Course Enrolment Events`,
      link: `/finances/course-enrolment-events`,
      icon: FileTerminal,
    },
    {
      label: t`Provider Causes`,
      link: `/finances/provider-causes`,
      icon: HeartHandshake,
    },
    {
      label: t`Billable Items`,
      link: `billable-items`,
      icon: Receipt,
    },
  ];

  return (
    <SidebarLayout items={items} label={t`Finances`}>
      <Outlet />
    </SidebarLayout>
  );
});
